import { AxiosService } from 'services';
export function GetDashBoard(start, end) {

  const endpoint  = start && end ? `/dashboard/?startDate=${start}&endDate=${end}` : '/dashboard/';

  return AxiosService().get(endpoint)
    .then(function (response) {
      return response.data;
    }).catch(function (error) {
      console.log(error);
    });
}
